export const environment = {
    apiRoot: '/api',
    production: true,
    tinymcePrefix: '/ui/tinymce'
};
